import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BlogPostContentPlaceholderInterface } from 'common/types/entities/BlogPostContentPlaceholderInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'

export function createBlogPostContentPlaceholder(
  parentId: string,
  masterBlockId?: MasterBlockIdType,
) {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.BlogPostContentPlaceholder,
      parentId,
      masterBlockId,
    ),
    padding: {
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
    },
    mobilePadding: {
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
    },
    isReadOnly: false,
    childIds: [],
  } as BlogPostContentPlaceholderInterface
}
